import { Component, Input, OnInit } from '@angular/core';
export interface StatusLegendItem {
    Name: string;
    Color: string;   // pode ser hex (#FF0000), rgb ou uma classe ionic
    Icon: string;    // nome do ícone do ion-icon (ex: "checkmark-circle")
}
@Component({
    selector: 'status-legend',
    templateUrl: './status-legend.component.html',
    styleUrls: ['./status-legend.component.scss'],
})
export class StatusLegendComponent implements OnInit {

    @Input('title') Title: string = 'Estados';
    @Input('items') Items: StatusLegendItem[] = [];

    constructor() { }

    ngOnInit() { }

}
